import css from './AddEditForm.module.css';

function AddEditForm({children}) {
    return (
        <div className={css.backdrop}>
            <div className={css.modal}>
                <form className={css.form}>
                    {children}
                    
                </form>
            </div>
        </div>
    );
}

export default AddEditForm;
